import { mainApi } from "../api/root-api"
import { getHistory, setFolio } from "../slices/orderSlice"
import { setError, setSuccess } from "../slices/statusSlice"
const accountsRoute = 'accounts'

export const createOrderAction = (id, form, token) => {
  return async (dispatch) => {
    let payload = {}
    const headers = { headers: { Authorization: token } }
    const url = `${accountsRoute}/${id}/services`
    await mainApi.post(url, form, headers).then(resp => {
      payload = {
        status: resp.status,
        message: `Pedido generado con exito con folio: ${ resp.data.folio }`
      }
      dispatch(setSuccess(payload))
      dispatch(setFolio(resp.data.folio))
    }).catch(err => {
      payload = {
        message: err.response.data.message.error,
        status: err.response.status
      }
      dispatch(setError(payload))
    })
  }
}


export const getOrderHistory = (token) => {
  const headers = {
    headers: {
      authorization: token
    }
  }
  return async ( dispatch ) => {
    await mainApi.get('services', headers).then(resp => {
      dispatch(getHistory(resp.data))
    }).catch(err => {
      const payload = {
        message: err.response.data.message.error,
        status: err.response.status
      }
      dispatch(setError(payload))
    })
  }
}